import { Button, Layout } from "matsuri-ui"
import { useNavigate, useParams } from "react-router-dom"
import styled from "@emotion/styled"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { genCleaningInfoPagePath } from "@/routes/protected"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"

const PageTitle = styled.div`
    font-size: 20px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
    margin-top: 40vh;
    text-align: center;
`

export const ConfirmPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)

    return (
        <main>
            <div>
                <PageTitle>{t("さらに報告しますか？")}</PageTitle>
            </div>

            <ReportFooter>
                <Layout.Column gap={2}>
                    <div>
                        <Button
                            variant="filled"
                            color="primary"
                            fullWidth
                            onClick={() => {
                                navigate(
                                    genCleaningInfoPagePath(
                                        cleaningId,
                                        "trouble"
                                    )
                                )
                            }}
                        >
                            {t("報告する")}
                        </Button>
                    </div>
                </Layout.Column>
            </ReportFooter>
        </main>
    )
}
